import {EditWindowMode, trimPoint, windowLandmark} from "../types/editorTypes";

export interface tempKeyMomentCuts{
    id: string;
    trim_points: trimPoint[];
    trim_labels: string[]
    landmarks: windowLandmark[];
    hidden_landmarks: windowLandmark[];
    coordinates: number[][];
    mode: EditWindowMode
    stream_reference?: number
}

export type KeyMomentCut = tempKeyMomentCuts & {
    key_moment_id: string,
    real_stream_reference: number
}

export interface tempKeyMoment{
    event: any;
    id: string;
    title: string;
    created_at: string;
    updated_at: string;
    duration: number;
    url: string;
    rating: number;
    frame_rate: number | null;
    tags: string[];
    away_score: number;
    home_score: number;
    play_time: number;
    period: string;
    stream_time_start: number;
    stream_time_end: number;
    thumbnail: string | null;
    lead: string | null;
    aspect_ratio: string;
    eyebrow: string;
    rubric: string;
    assignee: string;
    notes: string;
    event_id: string
    cut: tempKeyMomentCuts;
    global_seconds?: number;
    locked?: boolean;
    is_manual?: boolean;
}

export interface VolleyKeyMomentContent extends tempKeyMoment {
    "home_points": number,
    "away_points": number,
    "home_sets_won": number,
    "away_sets_won": number
}

export enum HIGHLIGHT_OPTION_SHEMA{
    RADIO_BUTTON = "RadioButton",
    CHECKBOX = "CheckBox",
}

export interface KeyMomentSetting{
    name: string,
    selected: boolean
    options: {
        schema?: HIGHLIGHT_OPTION_SHEMA;
        values?: {
            name: string
            value: boolean
            label: string
        }[]
    }
}
